import t from "react";
import { ScrollMenu as h, VisibilityContext as i } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";
/* empty css                    */
import { CheerfyFont as a } from "../CheerfyFont/CheerfyFont.js";
import { useDrag as p } from "../../../dom/hooks/useDrag.js";
import l from "./horizontalScroller.module.scss.js";
function b(r, e) {
  if (Math.abs(e.deltaX) !== 0 || Math.abs(e.deltaY) < 15) {
    e.stopPropagation();
    return;
  }
  e.deltaY < 0 ? r.scrollPrev() : e.deltaY > 0 && r.scrollNext();
}
function c({
  children: r,
  disabled: e,
  onClick: o
}) {
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      disabled: e,
      onClick: o,
      className: l.arrow,
      style: {}
    },
    r
  );
}
function g() {
  const {
    useIsVisible: r,
    scrollPrev: e
  } = t.useContext(i), o = r("first", !0);
  return /* @__PURE__ */ t.createElement(
    c,
    {
      disabled: o,
      onClick: () => e()
    },
    /* @__PURE__ */ t.createElement(a, { className: l.leftArrow, icon: "chevron" })
  );
}
function E() {
  const { scrollNext: r, useIsVisible: e } = t.useContext(
    i
  ), o = e("last", !0);
  return /* @__PURE__ */ t.createElement(
    c,
    {
      disabled: o,
      onClick: () => r()
    },
    /* @__PURE__ */ t.createElement(a, { className: l.rightArrow, icon: "chevron" })
  );
}
function M({ children: r, itemId: e }) {
  return /* @__PURE__ */ t.createElement(t.Fragment, { key: e }, r);
}
function A({
  children: r
}) {
  const {
    dragStart: e,
    dragStop: o,
    dragMove: m
  } = p(), u = ({ scrollContainer: n }) => (s) => m(s, (f) => {
    n.current && (n.current.scrollLeft += f);
  }), d = t.Children.map(r, (n, s) => /* @__PURE__ */ t.createElement(
    M,
    {
      itemId: s.toString()
    },
    n
  ));
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "horizontal-scroller",
      className: l.horizontalScroller,
      onMouseLeave: () => o
    },
    /* @__PURE__ */ t.createElement(
      h,
      {
        onWheel: b,
        onMouseDown: () => e,
        onMouseUp: () => o,
        onMouseMove: u,
        LeftArrow: g,
        RightArrow: E
      },
      d
    )
  );
}
export {
  A as HorizontalScroller,
  M as InnerElement,
  g as LeftArrow,
  E as RightArrow
};
//# sourceMappingURL=HorizontalScroller.js.map
